import { WorkLocationType } from '../work-location/types';

export const knownIpAddressFeatureKey = 'knownIpAddress';

export type KnownIpAddressModel = {
  id: number;
  address: string;
  /** Assigned work location. Null = address not qualified yet. Only writable field. */
  workLocationId?: number | null;
  workLocationName: string;
  workLocationType?: WorkLocationType | null;
  /** Localized label of the location type, empty when not qualified. */
  workLocationTypeLoc: string;
  workLocationCountedAsWork?: boolean | null;
  workLocationSalesTeamId?: number | null;
  workLocationSalesTeamName: string;
  /** First appearance of the address, in UTC. */
  creationDate: string;
};
export type KnownIpAddressFormModel = {
  id: number;
  workLocationId?: number | null;
};
